import { Layout } from '@/features/layout/types'
import Item from '@/features/settings/components/PrintManagement/components/Item'
import Button from '@/features/ui/buttons/components/Button'
import PlusIcon from '@/features/ui/icons/components/PlusIcon'
import PrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface HeaderProps {
    layout: Layout
    onAddPrinter: () => void
    addButtonDisabled?: boolean
}

const Header: FC<HeaderProps> = ({ layout, onAddPrinter, addButtonDisabled }) => {
    const { t } = useTranslation()

    const { styles } = useStyles(stylesheet, { layout })

    return (
        <Item>
            <View style={styles.container}>
                <View style={styles.headingContainer}>
                    <PrinterIcon width="24" height="24" />
                    <Typography.Heading variant="h3">
                        {t('settings.printers.printManagement.heading')}
                    </Typography.Heading>
                </View>
                <Button
                    onPress={onAddPrinter}
                    disabled={addButtonDisabled}
                    color="primary"
                    size="medium"
                    FrontIcon={PlusIcon}
                >
                    {t('settings.printers.printManagement.addPrinter').toUpperCase()}
                </Button>
            </View>
        </Item>
    )
}

const stylesheet = createStyleSheet({
    container: {
        width: '100%',
        variants: {
            layout: {
                compact: {
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 8,
                },
                extended: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                },
            },
        },
    },
    headingContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
})

export default Header
